var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6B119",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.212 18.2c-4.306 0-7.808-3.505-7.808-7.814 0-4.308 3.502-7.814 7.808-7.814 4.305 0 7.807 3.506 7.807 7.814 0 4.31-3.502 7.815-7.807 7.815zm0-17.814c-5.51 0-9.992 4.486-9.992 10 0 5.515 4.482 10 9.992 10 5.51 0 9.991-4.485 9.991-10 0-5.514-4.482-10-9.991-10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.075 10.396V6.203a.847.847 0 1 0-1.693 0v4.464c0 .013.003.025.004.039a.843.843 0 0 0 .244.64l3.153 3.156a.846.846 0 1 0 1.198-1.198l-2.906-2.908z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.e9080f137ee5c46c5248a6750db66c1d.svg";
export { ForwardRef as ReactComponent };